import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GeneralHealthComponent } from './views/general-health/general-health.component';
import { APP_BASE_HREF } from '@angular/common';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { AboutComponent } from './views/about/about.component';
import { AuthGuard } from './_helpers/auth.guard';
import { Role } from './models/role';

const routes: Routes = [
  { path: '', component: GeneralHealthComponent, canActivate: [AuthGuard], data: { roles: [Role.Admin, Role.VennHealth] } },
  { path: '404', component: NotFoundComponent },
  { path: 'about', component: AboutComponent, canActivate: [AuthGuard], data: { roles: [Role.Admin, Role.VennHealth] } },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
  ]
})
export class AppRoutingModule { }
